import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Close Month Use Case
 * Closes the month (marks checklist as closed)
 */
export class CloseMonthUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(checklistId: number): Promise<void> {
    return await this.repository.closeMonth(checklistId);
  }
}

